import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";

import type {
  AiContestAttachment,
  AiContestEnrollmentDraft,
  AiContestEnrollmentResult,
  AiContestMediaKind,
  AiContestWorkType,
} from "../types";

type UploadRaw = {
  key: string;
  file_url: string;
  media_id: string;
  file_name: string;
  content_type?: string | null;
  media_kind: AiContestMediaKind;
};

type EnrollmentRaw = {
  id: number;
  applicant_name: string;
  work_name: string;
  work_type: AiContestWorkType;
};

/** 公开上传报名附件。 */
export async function uploadAiContestAttachment(file: File): Promise<AiContestAttachment> {
  const form = new FormData();
  form.append("file", file);
  const response = await httpClient.post<ApiEnvelope<UploadRaw>>(
    "/ai-contest/enrollments/upload",
    form,
    { "axios-retry": { retries: 0 } },
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("报名附件上传接口返回了无效数据");
  }
  const data = response.data.data;
  return {
    mediaKey: data.key,
    fileUrl: data.file_url,
    fileName: data.file_name,
    contentType: data.content_type ?? undefined,
    mediaKind: data.media_kind,
  };
}

/** 公开提交报名。 */
export async function submitAiContestEnrollment(
  draft: AiContestEnrollmentDraft,
  attachments: AiContestAttachment[],
): Promise<AiContestEnrollmentResult> {
  if (!draft.workType) {
    throw new Error("请选择作品类型");
  }
  const response = await httpClient.post<ApiEnvelope<EnrollmentRaw>>(
    "/ai-contest/enrollments",
    {
      applicant_name: draft.applicantName.trim(),
      phone: draft.phone.trim(),
      school: draft.school.trim(),
      major: draft.major.trim(),
      region: draft.region.trim(),
      work_name: draft.workName.trim(),
      work_type: draft.workType,
      work_size: draft.workSize.trim(),
      remark: draft.remark.trim() || null,
      attachments: attachments.map((item) => ({
        media_key: item.mediaKey,
        file_url: item.fileUrl,
        file_name: item.fileName,
        content_type: item.contentType ?? null,
        media_kind: item.mediaKind,
      })),
    },
    { "axios-retry": { retries: 0 } },
  );
  if (response.data.code !== "OK" || !response.data.data) {
    throw new Error("报名提交接口返回了无效数据");
  }
  const data = response.data.data;
  return {
    id: data.id,
    applicantName: data.applicant_name,
    workName: data.work_name,
    workType: data.work_type,
  };
}
